import { render, staticRenderFns } from "./GenerationHistoryTable.vue?vue&type=template&id=36533523&scoped=true"
import script from "./GenerationHistoryTable.vue?vue&type=script&lang=ts"
export * from "./GenerationHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./GenerationHistoryTable.vue?vue&type=style&index=0&id=36533523&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36533523",
  null
  
)

export default component.exports